
import request from '@/utils/request'

//任务列表
export function taskList(params) {
  return request({
    url: '/gasTask/page',
    method: 'get',
    params:params
  })
}


//任务详情
export function taskDetail(params) {
  return request({
    url: '/gasTask/taskDetail',
    method: 'get',
    params:params
  })
}

//任务流水
export function taskFlow(params) {
  return request({
    url: '/gasTask/taskLog',
    method: 'get',
    params:params
  })
}


//流水导出
export function taskExport(data) {
	return request({
		url: '/gasTask/exportList',
		method: 'post',
		responseType: "blob",
		params: data
	})
}



// 问题相关----
// 问题列表
export function problemPage(params) {
  return request({
    url: '/gasTask/problemPage',
    method: 'get',
    params:params
  })
}


//问题统计
export function problemTotal(params) {
  return request({
    url: '/gasTask/problem',
    method: 'get',
    params:params
  })
}

//问题处理
export function processProblem(params) {
  return request({
    url: '/gasTask/processProblem',
    method: 'get',
    params:params
  })
}
//批量处理
export function processProblems(params) {
  return request({
    url: '/gasTask/processProblems',
    method: 'get',
    params:params
  })
}

//问题详情
export function problemDetail(params) {
  return request({
    url: '/gasTask/problemDetail',
    method: 'get',
    params:params
  })
}




//周期修改列表----
//周期修改列表
export function changePeriodPage(params) {
  return request({
    url: '/gasTask/changePeriodPage',
    method: 'get',
    params:params
  })
}
//周期审核
export function changePeriodAudit(params) {
  return request({
    url: '/gasTask/changePeriodAudit',
    method: 'get',
    params:params
  })
}
//周期审核流水
export function auditLogPage(params) {
  return request({
    url: '/gasTask/auditLogPage',
    method: 'get',
    params:params
  })
}